export enum AlertPositionType {
	Global = "global",
	ButtonCopyVideoLink = "button_copy_video_link",
	ActionButtonTop = "action_button_top",
}